/**
 * @project 中国人群健康大数据平台
 * 
 * @author  Guojun Wang
 * @date    2022-11-21 14:00:00
 **/ 

import React from 'react';

class Banner extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      default: true,
    };
  };

  componentDidMount() {

  };

  render() {
    const { ...currentProps } = this.props;
    const { dataSource } = currentProps;
    delete currentProps.dataSource;
    delete currentProps.isMobile;

    return (
      <div {...currentProps} {...dataSource.wrapper}>
        <div className='home-banner-wrapper'>
          <div className='home-banner-wrapper-module'>
            <div className='about-background'>
              <img src="/assets/images/about-us.png" alt='About Us' />
            </div>
            <div className='about-us'>
              <div className='about-us-left'>ABOUT US</div>
              <div className='about-us-right'>
                <span>关于平台介绍文案（英文），待补充 ...</span>
                {/* <span>(WLLSB) was inaugurated in July 2020. It is one of the first research laboratories funded by the Zhejiang Provincial Government. Led by Westlake University, WLLSB actively promotes the construction of innovative scientific research highland and uses cutting-edge research approaches in life sciences and biomedicine to explore two prominent and challenging research areas, namely aging- and metabolism-related diseases and cancer. WLLSB consists of four research centers: Basic Research Center, Translational Research Center, Genome Editing Center and the Center for Infectious Disease Research. Through interdisciplinary research and interconnected innovation, the laboratory integrates basic research, translational research, key technology development, clinical diagnosis, and treatment, as well as technology transfer. The laboratory develops a strategy emphasizing disease orientation, basic research, and multidisciplinary collaboration.</span> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Banner;
